export const iconFontAwesomeLogisticsTruckField = (
	<i className="fa-solid fa-truck-field"></i>
);
